import React from "react"
import { motion } from "framer-motion"
import Card from "./Card"

function CardGrid({ items, two }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      data-scroll-section
      className="container-fluid card-grid"
      key={two ? 1 : 0}
    >
      <div className="card-container card-left">
        {two
          ? items
              .slice(0, 2)
              .map((item) => <Card key={item.title} cardProp={item} />)
          : items
              .slice(0, 3)
              .map((item) => <Card key={item.title} cardProp={item} />)}
      </div>
      <div className="card-container card-center">
        {two
          ? items
              .slice(2, 4)
              .map((item) => <Card key={item.title} cardProp={item} />)
          : items
              .slice(3, 6)
              .map((item) => <Card key={item.title} cardProp={item} />)}
      </div>
      <div className="card-container card-right">
        {two
          ? items
              .slice(4)
              .map((item) => <Card key={item.title} cardProp={item} />)
          : items
              .slice(6)
              .map((item) => <Card key={item.title} cardProp={item} />)}
      </div>
    </motion.div>
  )
}

export default CardGrid
